import { render, staticRenderFns } from "./IndexComponent.vue?vue&type=template&id=b8ee87be&scoped=true&"
import script from "./IndexComponent.vue?vue&type=script&lang=js&"
export * from "./IndexComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndexComponent.vue?vue&type=style&index=0&id=b8ee87be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ee87be",
  null
  
)

export default component.exports